export enum BudgetLineItemType {
    Expense = "Expense",
    Income = "Income"
}
